import React from "react";
import ReactDOM from "react-dom/client";
import "./theme/theme.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applyTheme, getStoredTheme } from "./theme/themeStorage";
import { initViewportHeightTracking } from "./common/utils/viewportHeight";
import { applyBrandHead } from "./brands/applyBrandHead";

// Applied before the first render (not inside a component effect) so the page never flashes
// Light Theme for a frame before switching to a saved Dark Theme preference.
applyTheme(getStoredTheme());

// Swaps the browser tab title/favicon for NiksFit — same "before first render" timing as the
// theme above, so the tab never flashes HitFit's own title/icon first.
applyBrandHead();

// Mobile keyboard-aware popup sizing (see viewportHeight.js) — started once here rather than
// per-component so every Mobile popup's CSS can just read the resulting --hf-vvh variable.
initViewportHeightTracking();

const root = ReactDOM.createRoot(document.getElementById("root"));

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/service-worker.js")
//       .then((registration) => {
//         console.log(
//           "Service Worker registered with scope:",
//           registration.scope
//         );
//       })
//       .catch((error) => {
//         console.log("Service Worker registration failed:", error);
//       });
//   });
// }

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
